import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Modal} from 'antd';
import Cropper from "react-easy-crop";
import './styles.scss';

interface ImageCropModalInterface {
    open: boolean;
    onCancel: React.Dispatch<React.SetStateAction<boolean>>;
    imageUrl: string;
    onSubmit: Function;
}

interface CropInterface {
    width: number;
    height: number;
    x: number;
    y: number;
}


const ImageCropModal: React.FC<ImageCropModalInterface> = ({
                                                               open,
                                                               onCancel,
                                                               imageUrl,
                                                               onSubmit
                                                           }) => {
    const intl = useIntl();

    const [crop, setCrop] = useState({x: 0, y: 0})
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<CropInterface>();

    const onCropComplete = (croppedArea: any, croppedAreaPixels: any) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }

    const onCrop = () => {
        onSubmit(croppedAreaPixels)
        onCancel(false)
    }

    return (
        <Modal
            width={'70%'}
            open={open}
            destroyOnClose={true}
            title={intl.formatMessage({id: 'general.image_crop_modal'})}
            onOk={onCrop}
            onCancel={() => onCancel(false)}
            okText={intl.formatMessage({id: 'general.crop'})}
            cancelText={intl.formatMessage({id: 'general.cancel'})}
        >
            <div className={'crop-container'}>
                <Cropper
                    image={imageUrl}
                    crop={crop}
                    zoom={zoom}
                    aspect={4}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                />
            </div>
            <div className="controls">
                <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={(e: any) => setZoom(e.target.value)}
                    className="zoom-range"
                />
            </div>
        </Modal>
    )
};

export default ImageCropModal;
